//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ediDestination', {
//        templateUrl: 'views/components/views/ediDestination/ediDestination.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'ftpAccountsService', 'ediDestinationService', function ($stateParams, stateService, ftpAccountsService, ediDestinationService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let ediDestinationKeyno = $stateParams.edi_destination_keyno;
            
//            vm.model = {
//                edit: {},
//                selectListExternalTypes: [],
//                selectListFtpAccounts: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await ediDestinationService.getEdit({ edi_destination_keyno: ediDestinationKeyno }))[0];

//                vm.model.edit.ftp_remotefolder = atob(vm.model.edit.ftp_remotefolder);
//                vm.model.edit.ftp_localfolder = atob(vm.model.edit.ftp_localfolder);
//                vm.model.edit.folder_localfolder = atob(vm.model.edit.folder_localfolder);
//            }

//            async function loadExternalTypes() {
//                vm.model.selectListExternalTypes = await ediDestinationService.listExternalTypes();
//            }

//            async function loadFtpAccounts() {
//                vm.model.selectListFtpAccounts = await ftpAccountsService.listFtpAccounts();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region SAVE BUTTON FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                ediDestinationService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion SAVE BUTTON FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//                loadExternalTypes();
//                loadFtpAccounts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
